import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeAppointmentData } from "../../../StateManagement/Reducers/AppointmentsState";
import { Select, DatePicker } from "antd";
import dayjs from "dayjs";
import { SmallDatePickerStyle } from "./StyledComponents";
import {
  getFacilityList,
  getProvidersList,
  addAppointment,
  GetUpcomingAppointment,
  getProviderAvailablity,
  changeTime,
  GetBillingFacility,
  appointmentSaved,
  AppointmentEdited,
  clearAppointmentData,
  changeErrorObject,
  addAppointmentWaitList,
  editAppointmentWaitList,
  waitListAppointmentSaved,
} from "../../../StateManagement/Reducers/AppointmentsState";
import {
  AntdDateWrapper,
  AntdSelectWrapper,
  ModalInput,
} from "./StyledComponents";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

const { Option } = Select;

const AddAppointmentFormModal = ({ onClose, onSave }) => {
  const dispatch = useDispatch();

  const [savebtndisabled, setsavebtndisabled] = useState(false);

  const [activeSection, setActiveSection] = useState("morning");
  const {
    appointmentData,
    facilityList,
    providersList,
    providerAvailablity,
    loadingOffice,
    loadingProviders,
  } = useSelector((state) => state.Appointments);

  const bill_facility_id = useSelector(
    (state) => state.Appointments.BillingFacility,
  );

  const pid =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  /* ---------- COMMON STYLES ---------- */

  const labelStyle = {
    fontSize: "13px",
    fontWeight: 500,
    marginBottom: "6px",
    color: "#1f2937",
  };

  const availability = providerAvailablity ?? {};

  const timeSections = [
    { key: "morning", label: "Morning" },
    { key: "afternoon", label: "Afternoon" },
    { key: "evening", label: "Evening" },
  ];

  const selectStyle = {
    width: "100%",
  };

  const [isWaitListChecked, setIsWaitListChecked] = useState(false);

  const [waitListExtraInputs, setWaitListExtraInputs] = useState({
    priority: "",
    date: appointmentData.aptdate || "",
    fromTime: "",
    toTime: "",
  });

  const [priorityErr, setPriorityErr] = useState(false);
  const [dateErr, setDateErr] = useState(false);

  const specialityList = [
    { id: 1, name: "Plastic Surgery" },
    { id: 2, name: "Dermatology" },
    { id: 3, name: "Sleep Medicine" },
    { id: 4, name: "Allergy & Immunology" },
    { id: 5, name: "Concierge Medicine" },
    { id: 6, name: "Oncology" },
    { id: 7, name: "Endocrinology" },
    { id: 8, name: "Sports Medicine" },
    { id: 9, name: "Pediatrics" },
    { id: 10, name: "Cardiology" },
    { id: 11, name: "Neurology" },
    { id: 12, name: "Orthopedic Surgery" },
    { id: 13, name: "Psychiatry" },
    { id: 14, name: "Gastroenterology" },
    { id: 15, name: "Family Medicine" },
    { id: 16, name: "Urology" },
    { id: 17, name: "Radiology" },
    { id: 18, name: "Emergency Medicine" },
    { id: 19, name: "Ophthalmology" },
    { id: 20, name: "Pulmonology" },
    { id: 21, name: "Nephrology" },
    { id: 22, name: "Rheumatology" },
    { id: 23, name: "Dentistry" },
    { id: 24, name: "Physiotherapy" },
    { id: 25, name: "Other" },
  ];

  const apptTypeList = [
    { id: 1, name: "Appointment" },
    { id: 2, name: "Telehealth" },
  ];

  useEffect(() => {
    dispatch(getFacilityList({ find: "" }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(GetBillingFacility());
  }, [dispatch]);

  useEffect(() => {
    if (appointmentData.office) {
      dispatch(
        getProvidersList({
          name: "",
          facility_id: appointmentData.office,
          pid: pid, // 👈 decrypted PID
          selectSpeciality: appointmentData.speciality,
          appttype: appointmentData.appttype,
        }),
      );
    }
  }, [
    appointmentData.office,
    appointmentData.speciality,
    appointmentData.appttype,
    pid,
  ]);

  useEffect(() => {
    if (appointmentData?.changeUrl?.length > 0) {
      onClose();
    }
  }, [appointmentData?.changeUrl, onClose]);

  useEffect(() => {
    if (
      appointmentData.provider &&
      appointmentData.office &&
      appointmentData.aptdate
    ) {
      dispatch(
        getProviderAvailablity({
          pc_aid: appointmentData.provider,
          pc_facility: appointmentData.office,
          date: appointmentData.aptdate,
          appttype: appointmentData.appttype === "Telehealth" ? 2 : 1,
        }),
      );
    }
  }, [
    appointmentData.provider,
    appointmentData.office,
    appointmentData.aptdate,
    appointmentData.appttype,
  ]);

  // useEffect(() => {
  //   if (
  //     !appointmentData.provider &&
  //     !appointmentData.office &&
  //     !appointmentData.apttime &&
  //     appointmentData.eid === 0
  //   ) {
  //     onClose();
  //   }
  // }, [
  //   appointmentData.provider,
  //   appointmentData.office,
  //   appointmentData.apttime,
  //   appointmentData.eid,
  //   onClose,
  // ]);

  const saveWaitListAppointment = () => {
    let err = 0;

    if (!waitListExtraInputs.priority) {
      setPriorityErr(true);
      err = 1;
    }

    if (
      !waitListExtraInputs.date ||
      !waitListExtraInputs.fromTime ||
      !waitListExtraInputs.toTime
    ) {
      setDateErr(true);
      err = 1;
    }

    if (!appointmentData.provider || !appointmentData.office) {
      err = 1;
    }

    if (err) return;

    const priorityMap = {
      Urgent: 1,
      High: 2,
      Medium: 3,
      Low: 4,
    };

    const appttypenew = appointmentData.appttype === "Telehealth" ? 2 : 1;

    const article = {
      patient_id: pid,
      appt_type: appttypenew,
      facility: appointmentData.office,
      provider: appointmentData.provider,
      appt_date: waitListExtraInputs.date,
      pref_start_time: waitListExtraInputs.fromTime,
      pref_end_time: waitListExtraInputs.toTime,
      priority: priorityMap[waitListExtraInputs.priority],
      speciality: appointmentData.speciality,
      reason: appointmentData.reason,
      accepted: 0,
    };

    if (!appointmentData.eid || appointmentData.eid === 0) {
      dispatch(addAppointment(article));
    } else {
      dispatch(AppointmentEdited(article));
    }
  };

  return (
    <>
      <SmallDatePickerStyle />
      <div
        style={{
          width: "490px",
          maxHeight: "80vh",
          overflowY:
            isWaitListChecked ||
            (appointmentData.provider && appointmentData.aptdate)
              ? "auto"
              : "hidden",
          scrollbarWidth: "thin",
          paddingRight: "6px",
        }}
      >
        {/* ---------------- HEADER ---------------- */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "6px",
            paddingBottom: "0px",
          }}
        >
          <div
            style={{
              fontSize: "17px",
              fontWeight: 600,
              color: "#111827",
            }}
          >
            Create Appointment
          </div>

          <div
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={onClose}
          >
            ✕
          </div>
        </div>

        {/* ---------------- FACILITY ---------------- */}
        <div style={{ marginBottom: "8px" }}>
          <div style={labelStyle}>Facility</div>

          <Select
            size="middle"
            style={selectStyle}
            placeholder="Select Facility"
            value={
              facilityList?.find(
                (f) => Number(f.id) === Number(appointmentData.office),
              )?.id
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(val) => {
              dispatch(
                changeAppointmentData({ name: "office", value: Number(val) }),
              );

              dispatch(changeAppointmentData({ name: "provider", value: "" }));

              dispatch(changeTime(""));
              setActiveSection("morning");
            }}
          >
            {facilityList?.map((office) => (
              <Option key={office.id} value={office.id}>
                {office.name}
              </Option>
            ))}
          </Select>
        </div>

        {/* ---------------- SPECIALITY + TYPE ---------------- */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "14px",
            marginBottom: "8px",
          }}
        >
          <div>
            <div style={labelStyle}>Speciality</div>

            <Select
              size="middle"
              style={selectStyle}
              placeholder="Select Speciality"
              value={
                specialityList.find(
                  (x) => x.name === appointmentData.speciality,
                )?.id
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(val) => {
                const selected = specialityList.find((x) => x.id === val);
                dispatch(
                  changeAppointmentData({
                    name: "speciality",
                    value: selected.name,
                  }),
                );

                dispatch(
                  changeAppointmentData({ name: "provider", value: "" }),
                );
                dispatch(changeTime(""));
                setActiveSection("morning");
              }}
            >
              {specialityList?.map((sp) => (
                <Option key={sp.id} value={sp.id}>
                  {sp.name}
                </Option>
              ))}
            </Select>
          </div>

          <div>
            <div style={labelStyle}>Appointment Type</div>

            <Select
              size="middle"
              style={selectStyle}
              placeholder="Select Appointment Type"
              value={
                apptTypeList.find((x) => x.name === appointmentData.appttype)
                  ?.id
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(val) => {
                const selected = apptTypeList.find((x) => x.id === val);

                dispatch(
                  changeAppointmentData({
                    name: "appttype",
                    value: selected.name,
                  }),
                );
                dispatch(
                  changeAppointmentData({ name: "provider", value: "" }),
                );

                dispatch(changeTime(""));
                setActiveSection("morning");
              }}
            >
              {apptTypeList?.map((type) => (
                <Option key={type.id} value={type.id}>
                  {type.name}
                </Option>
              ))}
            </Select>
          </div>
        </div>

        {/* ---------------- PROVIDER ---------------- */}
        <div style={{ marginBottom: "8px" }}>
          <div style={labelStyle}>Provider</div>

          <Select
            size="middle"
            style={selectStyle}
            placeholder="Select Provider"
            value={
              providersList?.find(
                (p) => Number(p.id) === Number(appointmentData.provider),
              )?.id
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(val) => {
              dispatch(changeAppointmentData({ name: "provider", value: val }));
              dispatch(changeTime(""));
            }}
          >
            {providersList?.map((prov) => (
              <Option key={prov.id} value={prov.id}>
                {prov.name}
              </Option>
            ))}
          </Select>
        </div>

        {/* ---------------- DATE ---------------- */}
        <div className="appointment-modal" style={{ marginBottom: "8px" }}>
          <div style={labelStyle}>Date & Time</div>

          <DatePicker
            size="middle"
            style={{ width: "100%" }}
            placeholder="Select Date"
            value={
              appointmentData.aptdate ? dayjs(appointmentData.aptdate) : null
            }
            disabledDate={(current) =>
              current && current < dayjs().startOf("day")
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(date, dateString) => {
              dispatch(
                changeAppointmentData({ name: "aptdate", value: dateString }),
              );
              dispatch(changeTime(""));
              setActiveSection("morning");
            }}
          />
        </div>

        {isWaitListChecked && (
          <>
            {/* Preferred Date */}
            <div style={{ marginBottom: "8px" }}>
              <div style={labelStyle}>Preferred Date</div>

              <AntdDateWrapper>
                <DatePicker
                  style={{ width: "100%" }}
                  value={
                    waitListExtraInputs.date
                      ? dayjs(waitListExtraInputs.date)
                      : null
                  }
                  onChange={(date, dateString) =>
                    setWaitListExtraInputs((prev) => ({
                      ...prev,
                      date: dateString,
                    }))
                  }
                />
              </AntdDateWrapper>

              {dateErr && (
                <div
                  style={{
                    color: "#F65160",
                    fontSize: "12px",
                    marginTop: "4px",
                  }}
                >
                  Select preferred date & time
                </div>
              )}
            </div>

            {/* Time Range */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
                marginBottom: "8px",
              }}
            >
              <div>
                <div style={labelStyle}>From Time</div>
                <ModalInput
                  type="time"
                  value={waitListExtraInputs.fromTime}
                  onChange={(e) =>
                    setWaitListExtraInputs((prev) => ({
                      ...prev,
                      fromTime: e.target.value,
                    }))
                  }
                />
              </div>

              <div>
                <div style={labelStyle}>To Time</div>
                <ModalInput
                  type="time"
                  value={waitListExtraInputs.toTime}
                  onChange={(e) =>
                    setWaitListExtraInputs((prev) => ({
                      ...prev,
                      toTime: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            {/* Priority */}
            <div style={{ marginBottom: "8px" }}>
              <div style={labelStyle}>Priority</div>

              <AntdSelectWrapper>
                <Select
                  placeholder="Select Priority"
                  value={waitListExtraInputs.priority || undefined}
                  onChange={(val) => {
                    setPriorityErr(false);
                    setWaitListExtraInputs((prev) => ({
                      ...prev,
                      priority: val,
                    }));
                  }}
                >
                  <Option value="Urgent">Urgent</Option>
                  <Option value="High">High</Option>
                  <Option value="Medium">Medium</Option>
                  <Option value="Low">Low</Option>
                </Select>
              </AntdSelectWrapper>

              {priorityErr && (
                <div
                  style={{
                    color: "#F65160",
                    fontSize: "12px",
                    marginTop: "4px",
                  }}
                >
                  Select Priority
                </div>
              )}
            </div>
          </>
        )}

        <div style={{ marginBottom: "10px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
            onClick={() => setIsWaitListChecked(!isWaitListChecked)}
          >
            <input
              type="checkbox"
              checked={isWaitListChecked}
              onChange={(e) => setIsWaitListChecked(e.target.checked)}
              style={{
                width: "16px",
                height: "16px",
                accentColor: "#2C7BE5",
                cursor: "pointer",
              }}
            />
            <span
              style={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#374151",
              }}
            >
              Add to Waitlist
            </span>
          </div>
        </div>
        {appointmentData.provider &&
          appointmentData.aptdate &&
          !isWaitListChecked &&
          (loadingProviders ? (
            <div style={{ marginTop: "10px" }}>Loading slots...</div>
          ) : (
            <div style={{ marginBottom: "20px" }}>
              <div style={labelStyle}>Available Time Slots</div>

              {/* Horizontal Section Tabs */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "10px",
                  marginBottom: "15px",
                }}
              >
                {timeSections.map((section) => {
                  const isActive = activeSection === section.key;

                  return (
                    <div
                      key={section.key}
                      onClick={() => setActiveSection(section.key)}
                      style={{
                        padding: "6px 14px",
                        borderRadius: "20px",
                        fontSize: "13px",
                        cursor: "pointer",
                        background: isActive ? "#2C7BE5" : "#f3f4f6",
                        color: isActive ? "#fff" : "#374151",
                        fontWeight: 500,
                      }}
                    >
                      {section.label}
                    </div>
                  );
                })}
              </div>

              {/* Active Section Slots */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
                  gap: "8px",
                }}
              >
                {(availability[activeSection] || []).length > 0 ? (
                  (availability[activeSection] || []).map((slot, index) => {
                    const slotTime =
                      slot?.time || slot?.pc_startTime || slot?.start_time;

                    const isPast =
                      appointmentData.aptdate ===
                        dayjs().format("YYYY-MM-DD") &&
                      dayjs(
                        `${appointmentData.aptdate} ${slotTime}`,
                        "YYYY-MM-DD hh:mm A",
                      ).isBefore(dayjs());

                    const isSelected = appointmentData.apttime === slotTime;

                    return (
                      <div
                        key={index}
                        onClick={() => {
                          if (!isPast) {
                            dispatch(changeTime(slotTime));
                            dispatch(
                              changeErrorObject({
                                name: "noTime",
                                value: false,
                              }),
                            );
                          }
                        }}
                        style={{
                          textAlign: "center",
                          padding: "8px",
                          borderRadius: "6px",
                          cursor: isPast ? "not-allowed" : "pointer",
                          fontSize: "12px",
                          border: isSelected
                            ? "1px solid #2C7BE5"
                            : "1px solid #e5e7eb",
                          background: isPast
                            ? "#f3f4f6"
                            : isSelected
                              ? "#2C7BE5"
                              : "#fff",
                          color: isPast
                            ? "#9ca3af"
                            : isSelected
                              ? "#fff"
                              : "#374151",
                        }}
                      >
                        {slotTime}
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      gridColumn: "1 / -1",
                      padding: "6px",
                      fontSize: "12px",
                      color: "#9ca3af",
                    }}
                  >
                    No slots available
                  </div>
                )}
              </div>
            </div>
          ))}
        {/* ---------------- REASON ---------------- */}
        <div style={{ marginBottom: "18px" }}>
          <div style={labelStyle}>Reason for Visit</div>

          <textarea
            style={{
              width: "100%",
              minHeight: "60px",
              maxHeight: "120px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "10px",
              fontSize: "14px",
              resize: "vertical",
              outline: "none",
            }}
            placeholder="Enter reason"
            value={appointmentData.reason || ""}
            onChange={(e) =>
              dispatch(
                changeAppointmentData({
                  name: "reason",
                  value: e.target.value,
                }),
              )
            }
          />
        </div>

        {/* ---------------- FOOTER ---------------- */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button
            onClick={() => {
              dispatch(changeTime(""));
              onClose();
            }}
            style={{
              border: "1px solid #2C7BE5",
              background: "#fff",
              color: "#2C7BE5",
              padding: "6px 16px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            Cancel
          </button>

          <button
            disabled={savebtndisabled}
            onClick={() => {
              setsavebtndisabled(true);
              setTimeout(() => {
                setsavebtndisabled(false);
              }, 500);

              if (!pid) {
                alert("Invalid patient ID");
                return;
              }

              if (isWaitListChecked) {
                saveWaitListAppointment();
                return;
              }

              let err = false;

              if (!appointmentData.provider) err = true;
              if (!appointmentData.office) err = true;
              if (!appointmentData.speciality) err = true;
              if (!appointmentData.appttype) err = true;
              if (!appointmentData.aptdate) err = true;

              if (!appointmentData.apttime) {
                dispatch(changeErrorObject({ name: "noTime", value: true }));
                err = true;
              }

              if (err) return;

              const duration = 15;

              const baseTime = dayjs(
                appointmentData.aptdate + " " + appointmentData.apttime,
                "YYYY-MM-DD hh:mm A",
              );

              const endMoment = baseTime.add(duration, "minute");

              const startTime = baseTime.format("hh:mm A");
              const endTime = endMoment.format("hh:mm A");

              const startDate = baseTime.format("YYYY-MM-DD");
              const endDate = endMoment.format("YYYY-MM-DD");

              const seconds = duration * 60;

              const appttypenew =
                appointmentData.appttype === "Telehealth" ? 2 : 1;

              const article = {
                pc_pid: pid,
                pc_catid: 2,
                pc_aid: appointmentData.provider,
                pc_title: appttypenew === 2 ? "Tele Health" : "New Patient",
                pc_duration: seconds,
                pc_hometext: "",
                pc_apptstatus: "not_confirmed",
                pc_eventDate: startDate,
                pc_endDate: endDate,
                pc_startTime: startTime,
                pc_endTime: endTime,
                pc_facility: appointmentData.office,
                pc_informant: appointmentData.provider,
                pc_billing_location: bill_facility_id || 0,
                pc_select1: 0,
                pc_select2: 0,
                pc_untildate: "",
                pc_fromdate: startDate,
                pc_todate: startDate,
                days_wise: false,
                allday: false,
                repeats: "",
                appttype: appttypenew,
                walkin: false,
                encounter: appointmentData.encounter || 0,
                eid: appointmentData.eid || "",
                patient_reason: appointmentData.reason,
                speciality: appointmentData.speciality,
              };

              if (!appointmentData.eid || appointmentData.eid === 0) {
                dispatch(addAppointment(article));
              } else {
                dispatch(AppointmentEdited(article));
              }
              dispatch(GetUpcomingAppointment({ pid }));
              onClose();

              // dispatch(clearAppointmentData(""));
            }}
            style={{
              background: "#2C7BE5",
              color: "#fff",
              padding: "6px 18px",
              borderRadius: "6px",
              border: "none",

              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default AddAppointmentFormModal;
